import reduce from 'lodash/reduce';

type Queryables = {
  width: number;
};

type ParsedQuery = Record<string, number>;

type Queries = string[];
type QueryResults = Record<string, boolean>;

// Export parseQuery for testing
export const parseQuery = (query: string): ParsedQuery => {
  // Only works for `and` queries for now.
  const parts = query
    .split('and')
    .map(part => part.trim())
    // Remove parentheses
    .map(part => part.replace(/[()]/g, ''));
  return parts.reduce((accum: ParsedQuery, part: string) => {
    const [key = '', val = ''] = part.split(':');
    accum[key.trim()] = parseInt(val, 10);
    return accum;
  }, {});
};

// Export doesQueryMatch for testing if needed
export const doesQueryMatch = (
  queryables: Queryables,
  query: ParsedQuery
): boolean => {
  return [
    queryables.width >= (query['min-width'] || 0),
    queryables.width <= (query['max-width'] || Infinity),
  ].every(Boolean);
};

const findMatchingQueries = (
  queryables: Queryables,
  queries: Queries
): QueryResults => {
  return reduce(
    queries,
    (accum: QueryResults, queryToCheck: string) => {
      const mediaQuery = queryToCheck;
      const parsedQuery = parseQuery(mediaQuery);
      accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
      return accum;
    },
    {}
  );
};

export default findMatchingQueries;
